var dlsCard = {
  "dlsCard": {
    "height": "3.125rem"
  },
  "dlsCardXs": {
    "width": "4.375rem",
    "height": "2.75rem",
    "borderRadius": "0.125rem",
    "fontSize": "0.41Em"
  },
  "dlsCardSm": {
    "width": "7.125rem",
    "height": "4.5rem",
    "borderRadius": "0.25rem",
    "fontSize": "0.65Em"
  },
  "dlsCardMd": {
    "width": "9.25rem",
    "height": "5.875rem",
    "borderRadius": "0.375rem",
    "fontSize": "0.82Em"
  },
  "dlsCardLg": {
    "width": "14.5rem",
    "height": "9.1875rem",
    "borderRadius": "0.5625rem",
    "fontSize": "1.3Em"
  },
  "dlsCardXl": {
    "width": "315px",
    "height": "12.5rem",
    "borderRadius": "0.75rem",
    "fontSize": "1.75Em"
  }
};

export default dlsCard;
